module.exports = __webpack_public_path__ + "img/Clusters-Icon-B3.de53d7db.png";